export const MAX_CPI_THRESHOLD = 10;

export const HIGH_CPI_DRAWER_HEADING = 'High Buyer CPI';

export const HIGH_CPI_CONFIRMATION_TITLES = {
  /** Dashboard, bulk edit and the status-change flow. */
  survey: 'CPI Confirmation',
  /** Create/Edit Survey. */
  marginOverrideSurvey: 'Buyer CPI validation',
} as const;

export const HIGH_CPI_CONFIRMATION_MESSAGES = {
  survey:
    'You have entered a <span class="text-danger">HIGH CPI</span> of <span class="text-danger"><CURRENCY_SYMBOL><CPI></span>, please confirm that the value is entered exactly as you intend as all costs incurred will be billable.',
  project:
    'You have entered a <span class="text-danger">HIGH CPI</span> of <span class="text-danger"><CURRENCY_SYMBOL><CPI></span> in one or more surveys in this Survey Bundle. Please verify that this/these value/s is/are correct, as all incurred costs are fully billable.',
  marginOverrideSurvey: `You have entered a Buyer CPI that is greater than $${MAX_CPI_THRESHOLD}. Confirm that the value you entered is intended and correct.`,
} as const;

export const INLINE_HIGH_CPI_CONFIRMATION = {
  MESSAGE:
    'Please confirm the Override CPI value you have entered is accurate.',
  CONFIRM_LABEL: 'Confirm',
  UNCONFIRMED_ERROR: `You need to either confirm the Price warning notification or set the CPI lower than ${MAX_CPI_THRESHOLD}.`,
} as const;
